const CONTEXT_SELECTOR = '[data-lvtxiii-print-context]';
const CARD_SELECTOR = 'product-card';
const SPRITE_URL = 'https://cdn.shopify.com/s/files/1/0441/5019/4336/files/lvtxiii-pattern-sprite-101.webp?v=1788259924';
const SPRITE_COLUMNS = 11;
const SPRITE_ROWS = 10;
const SWATCH_SIZE = 48;

const PATTERN_POSITIONS = {
  BDZY:[0,0], BJYZ:[1,0], CSBZ:[2,0], CSHT:[3,0], CSSH:[4,0], CSYD:[5,0], DXYQ:[6,0], FGBH:[7,0], FGHT:[8,0], FGSY:[9,0], FLHT:[10,0],
  FYWH:[0,1], GDLW:[1,1], HBFH:[2,1], HBMS:[3,1], HBTW:[4,1], HDBH:[5,1], HDJH:[6,1], HDLH:[7,1], HDXRK:[8,1], HJYZ:[9,1], HLHT:[10,1],
  HLKT:[0,2], HLVHT:[1,2], HSJH:[2,2], HSMP:[3,2], HXT:[4,2], HYZ:[5,2], HZHT:[6,2], JBLY:[7,2], JLZL:[8,2], JRHH:[9,2], LANFD:[10,2],
  LANSY:[0,3], LBFH:[1,3], LBJY:[2,3], LCHH:[3,3], LDLH:[4,3], LDXH:[5,3], LGBY:[6,3], LHMD:[7,3], LJH:[8,3], LJLH:[9,3], LLHX:[10,3],
  LLLX:[0,4], LLXT:[1,4], LLYZ:[2,4], LSCL:[3,4], LVSY:[4,4], LVZL:[5,4], LVZYZ:[6,4], LXJY:[7,4], LYD:[8,4], LYLH:[9,4], LYMG:[10,4],
  LYWH:[0,5], LZRG:[1,5], MCYZ:[2,5], MHHT:[3,5], MXT:[4,5], MZXT:[5,5], NZFG:[6,5], NZKT:[7,5], NZXT:[8,5], OLFBE:[9,5], OLFDG:[10,5],
  OLFRE:[0,6], QHBT:[1,6], QHHT:[2,6], QHYQ:[3,6], QLHT:[4,6], QLVHT:[5,6], QLYH:[6,6], RDYH:[7,6], SMBH:[8,6], SMYZ:[9,6], SSGZ:[10,6],
  TWHL:[0,7], TWYWH:[1,7], TXHY:[2,7], WZQH:[3,7], XBDHTH:[4,7], XHFH:[5,7], XHH:[6,7], XHTH:[7,7], XLFH:[8,7], XLH:[9,7], XLT:[10,7],
  YDFG:[0,8], YGTW:[1,8], ZQBH:[2,8], ZQBT:[3,8], ZQBY:[4,8], ZQHT:[5,8], ZQJH:[6,8], ZQMP:[7,8], ZQTW:[8,8], ZQWJ:[9,8], ZQYG:[10,8],
  ZSQNH:[0,9], ZYH:[1,9],
};

const THROW_PILLOWS_COLLECTION_HANDLE = 'throw-pillows';
const THROW_PILLOWS_COVER_OVERRIDES = {
  'outdoor-throw-pillows-with-piping-18-x-18-in-set-of-2': {
    url: 'https://cdn.shopify.com/s/files/1/0441/5019/4336/files/lvtxiii-16-inch-outdoor-pillow-with-piping-cabana-black.jpg?v=1787986739',
    alt: 'LVTXIII outdoor throw pillows with piping in Cabana Black'
  }
};

function ensureStyles() {
  if (document.getElementById('lvtxiii-print-context-styles')) return;
  const style = document.createElement('style');
  style.id = 'lvtxiii-print-context-styles';
  style.textContent = `
    .lvtxiii-print-context-swatch {
      position: absolute;
      inset-inline-start: 12px;
      inset-block-end: 12px;
      width: ${SWATCH_SIZE}px;
      height: ${SWATCH_SIZE}px;
      border: 2px solid #fff;
      border-radius: 8px;
      box-shadow: 0 1px 5px rgb(0 0 0 / 22%);
      background-repeat: no-repeat;
      pointer-events: none;
      z-index: 3;
    }
    @media (max-width: 749px) {
      .lvtxiii-print-context-swatch {
        inset-inline-start: 8px;
        inset-block-end: 8px;
      }
    }
  `;
  document.head.appendChild(style);
}

function isThrowPillowsCollection() {
  const path = window.location.pathname.replace(/\/+$/, '');
  return path.endsWith(`/collections/${THROW_PILLOWS_COLLECTION_HANDLE}`);
}

function applyThrowPillowCoverOverride(card) {
  if (!(card instanceof HTMLElement) || !isThrowPillowsCollection()) return;

  const productLink = card.querySelector('a[ref="productCardLink"], a[ref="cardGalleryLink"], a[ref="productTitleLink"]');
  if (!(productLink instanceof HTMLAnchorElement) || !productLink.href) return;

  const productUrl = new URL(productLink.href, window.location.origin);
  const handle = productUrl.pathname.split('/products/')[1]?.split('/')[0];
  const override = handle ? THROW_PILLOWS_COVER_OVERRIDES[handle] : undefined;
  if (!override) return;

  const gallery = card.querySelector('.card-gallery');
  if (!(gallery instanceof HTMLElement)) return;

  for (const source of gallery.querySelectorAll('picture source')) {
    source.srcset = override.url;
  }

  for (const image of gallery.querySelectorAll('img')) {
    if (!(image instanceof HTMLImageElement)) continue;
    image.srcset = override.url;
    image.src = override.url;
    image.alt = override.alt;
    image.dataset.lvtxiiiCollectionCover = 'cabana-black';
  }
}

/**
 * Adds the contextual pattern swatch and syncs Shop by Print links to the selected variant.
 * @param {HTMLElement} card
 * @param {HTMLElement} context
 */
function addPatternSwatch(card, context) {
  if (context.dataset.patternThumbnail === 'true') return;
  const code = context.dataset.patternCode;
  const position = code ? PATTERN_POSITIONS[code] : undefined;
  if (!position) return;

  const gallery = card.querySelector('.card-gallery');
  if (!(gallery instanceof HTMLElement) || gallery.querySelector('.lvtxiii-print-context-swatch')) return;

  const [column, row] = position;
  const chip = document.createElement('span');
  chip.className = 'lvtxiii-print-context-swatch';
  chip.setAttribute('aria-hidden', 'true');
  chip.title = context.dataset.patternTitle || code;
  chip.style.backgroundImage = `url("${SPRITE_URL}")`;
  chip.style.backgroundSize = `${SPRITE_COLUMNS * SWATCH_SIZE}px ${SPRITE_ROWS * SWATCH_SIZE}px`;
  chip.style.backgroundPosition = `${-column * SWATCH_SIZE}px ${-row * SWATCH_SIZE}px`;
  gallery.appendChild(chip);
}

/**
 * Sync a Shop by Print product card to the variant selected by LVTXIII's SKU-suffix classifier.
 * This runs once per rendered card. Horizon's native variant picker remains authoritative after user interaction.
 * @param {Element} card
 */
function applyPrintContext(card) {
  if (!(card instanceof HTMLElement)) return;
  applyThrowPillowCoverOverride(card);
  if (card.dataset.lvtxiiiPrintContextApplied === 'true') return;

  const context = card.querySelector(CONTEXT_SELECTOR);
  if (!(context instanceof HTMLElement)) return;

  const variantId = context.dataset.variantId;
  if (!variantId) return;

  ensureStyles();
  addPatternSwatch(card, context);

  const variantUrl = context.dataset.variantUrl;
  const links = card.querySelectorAll('a[ref="productCardLink"], a[ref="cardGalleryLink"], a[ref="productTitleLink"]');

  for (const link of links) {
    if (!(link instanceof HTMLAnchorElement) || !link.href) continue;

    const url = new URL(link.href, window.location.origin);
    if (variantUrl) {
      const contextualUrl = new URL(variantUrl, window.location.origin);
      url.pathname = contextualUrl.pathname;
    }
    url.searchParams.set('variant', variantId);
    link.href = url.toString();
  }

  const mediaId = context.dataset.mediaId;
  if (mediaId) {
    const targetSlide = card.querySelector(`slideshow-slide[slide-id="${CSS.escape(mediaId)}"]`);
    const variantSlides = card.querySelectorAll('slideshow-slide[variant-image]');

    if (targetSlide instanceof HTMLElement) {
      for (const slide of variantSlides) {
        if (!(slide instanceof HTMLElement)) continue;
        slide.hidden = slide.getAttribute('slide-id') !== mediaId;
      }

      const slideshow = targetSlide.closest('slideshow-component') || card.querySelector('slideshow-component');
      customElements.whenDefined('slideshow-component').then(() => {
        requestAnimationFrame(() => {
          if (slideshow && typeof slideshow.select === 'function') {
            slideshow.select({ id: mediaId }, undefined, { animate: false });
          }
        });
      });
    }
  }

  card.dataset.lvtxiiiPrintContextApplied = 'true';
}

/** @param {ParentNode} root */
function applyAll(root = document) {
  if (root instanceof Element && root.matches(CARD_SELECTOR)) applyPrintContext(root);
  for (const card of root.querySelectorAll?.(CARD_SELECTOR) ?? []) applyPrintContext(card);
}

applyAll();

document.addEventListener('DOMContentLoaded', () => applyAll(), { once: true });
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) applyAll(event.target);
});

const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node instanceof Element) applyAll(node);
    }
  }
});

observer.observe(document.documentElement, { childList: true, subtree: true });
